import { ChartType, Colors, Styles, } from '@realize-reports/shared-charts';
import { first, takeUntil } from 'rxjs';
import { BaseComponent } from '../../shared/components/base.component';
import { Alignment, CEL_ICON_COLORS, CEL_ICON_NAMES, CEL_ICON_SIZES, SortingOrder, } from '../../shared/models/common.model';
import { StandardsPerformanceByProgramsHeaderLabel, } from '../model/realize-overview.model';
import * as i0 from "@angular/core";
import * as i1 from "../services/realize-overview/realize-overview.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../shared/components/info-popover/info-popover.component";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../libs/shared-charts/src/lib/column-chart/column-chart.component";
const _c0 = ["gridColumn"];
function StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_icon_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "realize-reports-overview-cel-icon", 20);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-size", ctx_r1.CelIconSizes.REGULAR)("data-color", ctx_r1.CelIconColors.GRAY_DUSTY)("data-aria-label", "Sort");
} }
function StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_icon_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "realize-reports-overview-cel-icon", 21);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-size", ctx_r2.CelIconSizes.REGULAR)("data-aria-label", "Sort")("data-color", ctx_r2.CelIconColors.GRAY_DUSTY);
} }
function StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_icon_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "realize-reports-overview-cel-icon", 21);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-size", ctx_r3.CelIconSizes.REGULAR)("data-aria-label", "Sort")("data-color", ctx_r3.CelIconColors.GRAY_DUSTY);
} }
const _c1 = function (a0) { return [a0]; };
function StandardsPerformanceByProgramsComponent_div_39_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24, 11)(3, "div", 25)(4, "span", 26);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 27);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 28)(9, "div", 29);
    i0.ɵɵelement(10, "realize-reports-column-chart", 30);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", item_r10.program);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r10.program, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r10.totalStandardsAccessed, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("data", item_r10.chartData)("axisLabelStyles", ctx_r9.axisLabelStyles)("xAxisConfigs", ctx_r9.xAxisConfigs)("yAxisConfigs", ctx_r9.yAxisConfigs)("plotOptionConfigs", ctx_r9.plotOptionConfigs)("seriesItems", item_r10.seriesData)("chartItems", ctx_r9.chartItems)("tooltipItems", i0.ɵɵpureFunction1(12, _c1, ctx_r9.tooltipItems[i_r11]))("tooltipConfigs", ctx_r9.tooltipConfigs);
} }
function StandardsPerformanceByProgramsComponent_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, StandardsPerformanceByProgramsComponent_div_39_ng_container_1_Template, 11, 14, "ng-container", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.standardsPerformanceChartData);
} }
function StandardsPerformanceByProgramsComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 31)(2, "div", 25);
    i0.ɵɵtext(3, "__");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵtext(5, "__");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 28);
    i0.ɵɵtext(7, "__");
    i0.ɵɵelementEnd()()();
} }
function StandardsPerformanceByProgramsComponent_ng_template_41_realize_reports_overview_cel_icon_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "realize-reports-overview-cel-icon", 34);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-size", ctx_r13.CelIconSizes.SMALL)("data-color", ctx_r13.CelIconColors.PRIMARY)("data-aria-label", "Arrow down");
} }
function StandardsPerformanceByProgramsComponent_ng_template_41_realize_reports_overview_cel_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "realize-reports-overview-cel-icon", 35);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-size", ctx_r14.CelIconSizes.SMALL)("data-color", ctx_r14.CelIconColors.PRIMARY)("data-aria-label", "Arrow up");
} }
function StandardsPerformanceByProgramsComponent_ng_template_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, StandardsPerformanceByProgramsComponent_ng_template_41_realize_reports_overview_cel_icon_0_Template, 1, 3, "realize-reports-overview-cel-icon", 32);
    i0.ɵɵtemplate(1, StandardsPerformanceByProgramsComponent_ng_template_41_realize_reports_overview_cel_icon_1_Template, 1, 3, "realize-reports-overview-cel-icon", 33);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r7.currentSortedColumnOrder === ctx_r7.SortingOrder.Descending);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.currentSortedColumnOrder === ctx_r7.SortingOrder.Ascending);
} }
function StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_loader_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "realize-reports-overview-cel-loader", 36);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isLoading", ctx_r8.isLoading);
} }
export class StandardsPerformanceByProgramsComponent extends BaseComponent {
    constructor(realizeOverviewService, translateService, renderer) {
        super();
        this.realizeOverviewService = realizeOverviewService;
        this.translateService = translateService;
        this.renderer = renderer;
        this.CharWidth = 6.9; // Width of a single "14px Open Sans" character in pixels.
        this.axisLabelStyles = {
            fontSize: Styles.FONT_SIZE_12,
            fontFamily: Styles.OPEN_SANS,
            color: Colors.BLACK,
        };
        this.xAxisConfigs = {
            lineWidth: 0,
            lineColor: Colors.BLACK,
            labelRotation: -45,
            labelsEnabled: false,
        };
        this.yAxisConfigs = {
            lineWidth: 0,
            lineColor: Colors.BLACK,
            tickAmount: 0,
            tickColor: Colors.WHITE_SMOKE_STRONG,
            min: 0,
            max: undefined,
            stackLabels: false,
            labelsFormat: '{value}',
            labelsEnabled: false,
        };
        this.plotOptionConfigs = {
            maxPointWidth: 24,
            hover: true,
            stacking: 'percent',
            groupPadding: 0,
            pointPadding: 0,
            borderWidth: 1,
        };
        this.chartItems = {
            height: '24',
            width: null,
            type: ChartType.BAR,
            margin: [0, 0, 0, 0],
            drawSVGArrow: false,
            spacing: [0, 0, 0, 0],
            animation: false,
            enableDynamicDataLabelPlacement: true,
        };
        this.tooltipConfigs = {
            showTooltip: true,
            sharedTooltip: true,
            tooltipDelay: 0,
            tooltipWidth: 229,
        };
        this.tooltipItems = [];
        this.standardsPerformanceByPrograms = [];
        this.standardsPerformanceChartData = [];
        this.isLoading = true;
    }
    ngOnInit() {
        this.subscribeToStandardsPerformancePrograms();
    }
    ngAfterViewChecked() {
        const maxChar = Math.min(this.standardsPerformanceByPrograms.reduce((max, item) => { var _a, _b; return Math.max(max, (_b = (_a = item.programName) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); }, 0), 74);
        const maxWidth = Math.max(maxChar * this.CharWidth, 200);
        this.gridColumn.forEach((item) => {
            this.renderer.setStyle(item.nativeElement, 'grid-template-columns', `${maxWidth}px 150px 1fr`);
        });
    }
    subscribeToStandardsPerformancePrograms() {
        this.realizeOverviewService
            .standardsPerformanceByPrograms()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((standardsPerformanceData) => {
            var _a, _b;
            this.standardsPerformanceByPrograms =
                (_b = (_a = standardsPerformanceData.standardsPerformanceByPrograms) === null || _a === void 0 ? void 0 : _a.standardsPerformanceByPrograms) !== null && _b !== void 0 ? _b : [];
            this.populateStandardsPerformance();
            this.handleSortIconClick(StandardsPerformanceByProgramsHeaderLabel.TOTAL_STANDARDS_ASSESSED);
            this.isLoading = false;
        });
    }
    populateStandardsPerformance() {
        this.standardsPerformanceChartData = this.standardsPerformanceByPrograms.map((item) => {
            var _a, _b, _c, _d, _e;
            return ({
                program: (_a = item.programName) !== null && _a !== void 0 ? _a : '',
                totalStandardsAccessed: (_b = item.totalStandardsAssessed) !== null && _b !== void 0 ? _b : 0,
                chartData: [
                    {
                        label: (_c = item.programName) !== null && _c !== void 0 ? _c : '',
                        point1: Math.round((_d = item.percentageOfStandardsNotMastered) !== null && _d !== void 0 ? _d : 0),
                        point2: Math.round((_e = item.percentageOfStandardsMastered) !== null && _e !== void 0 ? _e : 0),
                    },
                ],
                seriesData: this.populateSeriesItem(item),
            });
        });
        this.tooltipConfiguration();
    }
    populateSeriesItem(item) {
        var _a, _b;
        const mastered = Math.round((_a = item.percentageOfStandardsMastered) !== null && _a !== void 0 ? _a : 0);
        const notMastered = Math.round((_b = item.percentageOfStandardsNotMastered) !== null && _b !== void 0 ? _b : 0);
        return [
            {
                name: '',
                data: [notMastered],
                color: Colors.LABEL_RED,
                hoverColor: Colors.LABEL_RED_HOVER,
            },
            {
                name: '',
                data: [mastered],
                color: Colors.GREEN_DARK,
                hoverColor: Colors.GREEN_DARK_HOVER,
                dataLabel: {
                    enabled: true,
                    align: Alignment.LEFT,
                    color: Colors.WHITE,
                    format: '{point.y}%',
                    fontFamily: Styles.OPEN_SANS_BOLD,
                    fontSize: Styles.FONT_SIZE_14,
                    inside: this.handleDataLabelPlacement(mastered) === 'inside',
                },
            },
        ];
    }
    handleDataLabelPlacement(value) {
        return value < 10 ? 'outside' : 'inside';
    }
    handleSortIconClick(key) {
        if (!this.standardsPerformanceByPrograms)
            return;
        const previousSortedColumnKey = this.currentSortedColumnKey;
        if (!this.currentSortedColumnKey || previousSortedColumnKey !== key) {
            this.currentSortedColumnOrder = SortingOrder.Descending;
        }
        else {
            this.currentSortedColumnOrder =
                this.currentSortedColumnOrder === SortingOrder.Ascending
                    ? SortingOrder.Descending
                    : SortingOrder.Ascending;
        }
        this.currentSortedColumnKey = key;
        const dataCopy = [...this.standardsPerformanceByPrograms];
        this.standardsPerformanceByPrograms = dataCopy.sort((currentElement, nextElement) => {
            const [currentValue, nextValue] = this.extractComparisonValues(currentElement, nextElement, key);
            if (this.currentSortedColumnOrder === SortingOrder.Ascending) {
                return currentValue > nextValue ? 1 : -1;
            }
            else {
                return currentValue < nextValue ? 1 : -1;
            }
        });
        this.populateStandardsPerformance();
    }
    extractComparisonValues(currentElement, nextElement, key) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (key) {
            case StandardsPerformanceByProgramsHeaderLabel.PROGRAM:
                const currentProgram = (_b = (_a = currentElement.programName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : '';
                const nextProgram = (_d = (_c = nextElement.programName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) !== null && _d !== void 0 ? _d : '';
                return [currentProgram, nextProgram];
            case StandardsPerformanceByProgramsHeaderLabel.TOTAL_STANDARDS_ASSESSED:
                const currentTotalStandardsAccessed = (_e = currentElement.totalStandardsAssessed) !== null && _e !== void 0 ? _e : 0;
                const nextTotalStandardsAccessed = (_f = nextElement.totalStandardsAssessed) !== null && _f !== void 0 ? _f : 0;
                return [currentTotalStandardsAccessed, nextTotalStandardsAccessed];
            case StandardsPerformanceByProgramsHeaderLabel.TOTAL_ASSESSED_STANDARDS_MASTERED:
                const currentAccessedStandardsMastered = (_g = currentElement.percentageOfStandardsMastered) !== null && _g !== void 0 ? _g : 0;
                const nextAccessedStandardsMastered = (_h = nextElement.percentageOfStandardsMastered) !== null && _h !== void 0 ? _h : 0;
                return [currentAccessedStandardsMastered, nextAccessedStandardsMastered];
            default:
                throw new Error('invalid key is being sorted');
        }
    }
    tooltipConfiguration() {
        this.translateService
            .get([
            'standards-performance.tooltip.standards-mastered',
            'standards-performance.tooltip.standards-not-mastered',
        ])
            .pipe(first())
            .subscribe((translatedValues) => {
            this.tooltipItems = this.standardsPerformanceByPrograms.map((data) => {
                var _a;
                return ({
                    id: (_a = data.programName) !== null && _a !== void 0 ? _a : '',
                    element: this.tooltipHTMLConfig(data, Object.values(translatedValues)),
                });
            });
        });
    }
    tooltipHTMLConfig(data, translatedValues) {
        var _a, _b, _c, _d, _e;
        return `
            <div style='color: ${Colors.GRAY_DARKER};font-size: ${Styles.FONT_SIZE_12};padding: 8px; border-radius: 5px;  box-shadow: ${Styles.SHADOW_ELEVATION_THREE}; background-color: ${Colors.WHITE}'>
                <div style="padding-bottom: 8px; font-family:${Styles.OPEN_SANS_BOLD}">${(_a = data.programName) !== null && _a !== void 0 ? _a : ''}</div>
                    <div  style="font-family: ${Styles.POPPINS}; ">${translatedValues[0]}</div>
                    <div style="padding-bottom: 8px; font-family:${Styles.OPEN_SANS_BOLD}">${((_b = data.totalStandardsMastered) !== null && _b !== void 0 ? _b : 0).toFixed(0)} (${((_c = data.percentageOfStandardsMastered) !== null && _c !== void 0 ? _c : 0).toFixed(0)}%)</div>
                    <div style="font-family: ${Styles.POPPINS}; ">${translatedValues[1]}</div>
                    <div style="font-family:${Styles.OPEN_SANS_BOLD}">${((_d = data.totalStandardsNotMastered) !== null && _d !== void 0 ? _d : 0).toFixed(0)} (${((_e = data.percentageOfStandardsNotMastered) !== null && _e !== void 0 ? _e : 0).toFixed(0)}%)</div>
            </div>
        `;
    }
    get CelIconColors() {
        return CEL_ICON_COLORS;
    }
    get CelIconNames() {
        return CEL_ICON_NAMES;
    }
    get CelIconSizes() {
        return CEL_ICON_SIZES;
    }
    get StandardsPerformanceByProgramsHeaderLabel() {
        return StandardsPerformanceByProgramsHeaderLabel;
    }
    get SortingOrder() {
        return SortingOrder;
    }
    ngOnDestroy() {
        super.destroy();
    }
}
StandardsPerformanceByProgramsComponent.ɵfac = function StandardsPerformanceByProgramsComponent_Factory(t) { return new (t || StandardsPerformanceByProgramsComponent)(i0.ɵɵdirectiveInject(i1.RealizeOverviewService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.Renderer2)); };
StandardsPerformanceByProgramsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandardsPerformanceByProgramsComponent, selectors: [["realize-reports-overview-standards-performance-by-programs"]], viewQuery: function StandardsPerformanceByProgramsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.gridColumn = _t);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 44, vars: 30, consts: [[1, "standards-performance-header"], [1, "standards-performance-header-content"], [3, "message"], [1, "standards-performance-container"], [1, "standards-performance-legends"], [1, "standards-performance-legends-item"], [1, "standards-performance-legends-icon", "standards-performance-colors-green"], [1, "standards-performance-legends-text"], [1, "standards-performance-legends-icon", "standards-performance-colors-red"], [1, "standards-performance-chart"], [1, "standards-performance-chart-header", "grid-structure"], ["gridColumn", ""], [1, "standards-performance-chart-header-item"], [3, "click"], ["data-name", "arrow-sort", 4, "ngIf", "ngIfElse"], ["class", "sorting-icon", "data-name", "arrow-sort", 4, "ngIf", "ngIfElse"], [1, "standards-performance-chart-header-item", "standards-mastered"], ["class", "standards-performance-chart-box", 4, "ngIf"], ["single_arrow", ""], ["class", "standards-performance-spinner", 3, "isLoading", 4, "ngIf"], ["data-name", "arrow-sort"], ["data-name", "arrow-sort", 1, "sorting-icon"], [1, "standards-performance-chart-box"], [4, "ngFor", "ngForOf"], [1, "standards-performance-chart-row", "grid-structure"], [1, "standards-performance-chart-item"], ["id", "program-name", 1, "standards-performance-chart-school", 3, "title"], [1, "standards-performance-chart-item", "total-standards-accessed"], [1, "standards-performance-chart-item", "standards-mastered"], [1, "standards-performance-chart-wrapper"], [3, "data", "axisLabelStyles", "xAxisConfigs", "yAxisConfigs", "plotOptionConfigs", "seriesItems", "chartItems", "tooltipItems", "tooltipConfigs"], [1, "standards-performance-chart-row", "grid-structure", "zero-state-container"], ["data-name", "arrow-down", "tabindex", "0", 4, "ngIf"], ["data-name", "arrow-up", "tabindex", "0", 4, "ngIf"], ["data-name", "arrow-down", "tabindex", "0"], ["data-name", "arrow-up", "tabindex", "0"], [1, "standards-performance-spinner", 3, "isLoading"]], template: function StandardsPerformanceByProgramsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "header", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "realize-reports-overview-info-popover", 2);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3)(7, "div", 4)(8, "div", 5);
        i0.ɵɵelement(9, "div", 6);
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 5);
        i0.ɵɵelement(14, "div", 8);
        i0.ɵɵelementStart(15, "div", 7);
        i0.ɵɵtext(16);
        i0.ɵɵpipe(17, "translate");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(18, "div", 9)(19, "header", 10, 11)(21, "div", 12)(22, "span");
        i0.ɵɵtext(23);
        i0.ɵɵpipe(24, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "span", 13);
        i0.ɵɵlistener("click", function StandardsPerformanceByProgramsComponent_Template_span_click_25_listener() { return ctx.handleSortIconClick(ctx.StandardsPerformanceByProgramsHeaderLabel.PROGRAM); });
        i0.ɵɵtemplate(26, StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_icon_26_Template, 1, 3, "realize-reports-overview-cel-icon", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(27, "div", 12)(28, "span");
        i0.ɵɵtext(29);
        i0.ɵɵpipe(30, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "span", 13);
        i0.ɵɵlistener("click", function StandardsPerformanceByProgramsComponent_Template_span_click_31_listener() { return ctx.handleSortIconClick(ctx.StandardsPerformanceByProgramsHeaderLabel.TOTAL_STANDARDS_ASSESSED); });
        i0.ɵɵtemplate(32, StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_icon_32_Template, 1, 3, "realize-reports-overview-cel-icon", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(33, "div", 16)(34, "span");
        i0.ɵɵtext(35);
        i0.ɵɵpipe(36, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "span", 13);
        i0.ɵɵlistener("click", function StandardsPerformanceByProgramsComponent_Template_span_click_37_listener() { return ctx.handleSortIconClick(ctx.StandardsPerformanceByProgramsHeaderLabel.TOTAL_ASSESSED_STANDARDS_MASTERED); });
        i0.ɵɵtemplate(38, StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_icon_38_Template, 1, 3, "realize-reports-overview-cel-icon", 15);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(39, StandardsPerformanceByProgramsComponent_div_39_Template, 2, 1, "div", 17);
        i0.ɵɵtemplate(40, StandardsPerformanceByProgramsComponent_div_40_Template, 8, 0, "div", 17);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(41, StandardsPerformanceByProgramsComponent_ng_template_41_Template, 2, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(43, StandardsPerformanceByProgramsComponent_realize_reports_overview_cel_loader_43_Template, 1, 1, "realize-reports-overview-cel-loader", 19);
    } if (rf & 2) {
        const _r6 = i0.ɵɵreference(42);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 16, "headers.standards-performance-by-programs"));
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(5, 18, "icon-content.standard-performance-by-programs"));
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 20, "standards-performance.legends.above-70"), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 22, "standards-performance.legends.below-70"), " ");
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 24, ctx.StandardsPerformanceByProgramsHeaderLabel.PROGRAM));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.currentSortedColumnKey !== ctx.StandardsPerformanceByProgramsHeaderLabel.PROGRAM)("ngIfElse", _r6);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 26, ctx.StandardsPerformanceByProgramsHeaderLabel.TOTAL_STANDARDS_ASSESSED));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.currentSortedColumnKey !== ctx.StandardsPerformanceByProgramsHeaderLabel.TOTAL_STANDARDS_ASSESSED)("ngIfElse", _r6);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 28, ctx.StandardsPerformanceByProgramsHeaderLabel.TOTAL_ASSESSED_STANDARDS_MASTERED), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.currentSortedColumnKey !== ctx.StandardsPerformanceByProgramsHeaderLabel.TOTAL_ASSESSED_STANDARDS_MASTERED)("ngIfElse", _r6);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.standardsPerformanceChartData.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.standardsPerformanceChartData.length && !ctx.isLoading);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isLoading);
    } }, directives: [i3.InfoPopoverComponent, i4.NgIf, i4.NgForOf, i5.ColumnChartComponent], pipes: [i2.TranslatePipe], styles: [".lst-table-responsive-wrapper[_ngcontent-%COMP%] {\n  width: var(--lst-table-responsive-wrapper-width, auto);\n  height: var(--lst-table-responsive-wrapper-height, auto);\n  overflow: var(--lst-table-responsive-wrapper-overflow, scroll);\n}\n.lst-table[_ngcontent-%COMP%] {\n  border-collapse: var(--lst-table-border-collapse, collapse);\n  border: var(--lst-table-border, none);\n  background-color: #fff;\n  font-family: var(--lst-table-font-family, \"OpenSans\");\n  line-height: var(--lst-table-line-height, 20px);\n  font-size: var(--lst-table-font-size, 0.875rem);\n}\n.lst-table.compact[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%], .lst-table.compact[_ngcontent-%COMP%]    > tbody[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n  padding-top: var(--lst-table-padding-top-compact, 8.5px);\n  padding-bottom: var(--lst-table-padding-top-compact, 8.5px);\n}\n.lst-table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%] {\n  border-top: var(--lst-table-header-row-border-top, none);\n  background-color: #fff;\n  line-height: var(--lst-table-header-row-line-height, 20px);\n  padding: var(--lst-table-padding, 17px 8px);\n}\n.lst-table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%] {\n  border-top: var(--lst-table-th-border-top, none);\n  border-left: var(--lst-table-th-border-left, none);\n  border-right: var(--lst-table-th-border-right, none);\n  border-bottom: var(--lst-table-th-border-bottom, 1px solid #555);\n  font-family: var(--lst-table-th-font-family, \"OpenSans-Semibold\");\n  font-size: var(--lst-table-th-font-size, 0.875rem);\n  line-height: var(--lst-table-th-line-height, 20px);\n  padding: var(--lst-table-th-padding, 8px 4px);\n  min-width: var(--lst-table-th-min-width, 64px);\n  max-width: var(--lst-table-th-max-width, none);\n  text-align: var(--lst-table-th-text-align, left);\n  vertical-align: var(--lst-table-th-vertical-align, middle);\n  white-space: nowrap;\n}\n.lst-table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th[_ngcontent-%COMP%]    > .lst-table-header-icon[_ngcontent-%COMP%] {\n  vertical-align: var(--lst-table-header-icon-vertical-align, middle);\n  margin-bottom: var(--lst-table-header-icon-margin-bottom, 1px 0);\n}\n.lst-table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.align-center[_ngcontent-%COMP%] {\n  text-align: center;\n}\n.lst-table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.interactive[_ngcontent-%COMP%]:hover {\n  background-color: var(--lst-table-th-interactive-hover-bg-color, #e5f0f9);\n  border-radius: var(--interactive-hover-th-border-radius, 4px 4px 0 0);\n}\n.lst-table[_ngcontent-%COMP%]    > thead[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > th.interactive[_ngcontent-%COMP%]:hover:has(.lst-table-select) {\n  border-radius: var(--interactive-hover-select-th-border-radius, 4px 0 0 0);\n  --primary-select-background-color: #e5f0f9;\n  --primary-styling-label-color: #2150a3;\n  --select-caret-down-color-base: #2150a3;\n}\n.lst-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%] {\n  border-top: var(--lst-table-tr-border-top, none);\n  border-left: var(--lst-table-tr-border-left, none);\n  border-right: var(--lst-table-tr-border-right, none);\n  border-bottom: var(--lst-table-tr-border-bottom, 1px solid #d8d8d8);\n  background-color: #fff;\n}\n.lst-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover {\n  background-color: var(--lst-tr-hover-bg-color, #e5f0f9);\n}\n.lst-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n  font-size: var(--lst-table-td-font-size, 0.875rem);\n  border-bottom: var(--lst-table-td-border-bottom, none);\n  border-left: var(--lst-table-td-border-left, none);\n  border-right: var(--lst-table-td-border-right, none);\n  padding: var(--lst-table-padding, 17px 8px);\n}\n.lst-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]    > td.align-center[_ngcontent-%COMP%] {\n  text-align: center;\n}\n.lst-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]    > td.align-left[_ngcontent-%COMP%] {\n  padding-left: var(--lst-table-td-align-left-padding, none);\n  text-align: left;\n}\n.lst-table[_ngcontent-%COMP%]   .lst-table-select[_ngcontent-%COMP%] {\n  margin-right: 4px;\n  --single-select-label-font-size: $text-size-small;\n  --single-select-label-font-family: $secondary-font-medium;\n  --label-margin-bottom-borderless: 0;\n}\n\n\n\n.standards-performance-header[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6.5px 16px 6.5px 24px;\n  background-color: #6f777b;\n  border-radius: 4px 4px 0 0;\n  font-family: Poppins-SemiBold;\n  font-size: 1.125rem;\n  color: #fff;\n}\n.standards-performance-header-content[_ngcontent-%COMP%] {\n  font-family: Poppins-SemiBold;\n  font-size: 1.125rem;\n  margin-bottom: 0;\n}\n.standards-performance-spinner[_ngcontent-%COMP%] {\n  height: 346px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.standards-performance-legends[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: flex-end;\n  margin: 8px 24px 20px 26px;\n  color: #333;\n}\n.standards-performance-legends-item[_ngcontent-%COMP%] {\n  display: flex;\n}\n.standards-performance-legends-item[_ngcontent-%COMP%]:first-of-type {\n  margin-right: 16px;\n}\n.standards-performance-legends-icon[_ngcontent-%COMP%] {\n  height: 10px;\n  width: 10px;\n  margin-right: 3px;\n  margin-top: 3.25px;\n}\n.standards-performance-legends-text[_ngcontent-%COMP%] {\n  font-family: OpenSans-Semibold;\n  font-size: 0.75rem;\n}\n.standards-performance-colors-green[_ngcontent-%COMP%] {\n  background-color: #3c8725;\n}\n.standards-performance-colors-red[_ngcontent-%COMP%] {\n  background-color: #CC333F;\n}\n.standards-performance-chart[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.standards-performance-chart-box[_ngcontent-%COMP%] {\n  max-height: 346px;\n  overflow-y: auto;\n  padding: 0 24px 20px 26px;\n}\n.standards-performance-chart[_ngcontent-%COMP%]   .grid-structure[_ngcontent-%COMP%] {\n  display: grid;\n  grid-template-columns: 200px 150px 1fr;\n  grid-column-gap: 42px;\n  column-gap: 42px;\n}\n@media only screen and (max-width: 1024px) {\n  .standards-performance-chart[_ngcontent-%COMP%]   .grid-structure[_ngcontent-%COMP%] {\n    grid-template-columns: 300px 150px 1fr !important;\n  }\n}\n.standards-performance-chart[_ngcontent-%COMP%]   .standards-mastered[_ngcontent-%COMP%] {\n  padding-left: 38px;\n  min-width: 0;\n}\n.standards-performance-chart-wrapper[_ngcontent-%COMP%] {\n  width: 100%;\n}\n.standards-performance-chart[_ngcontent-%COMP%]   .total-standards-accessed[_ngcontent-%COMP%] {\n  font-family: OpenSans-Bold;\n  color: #333;\n  font-size: 0.875rem;\n}\n.standards-performance-chart[_ngcontent-%COMP%]   .zero-state-container[_ngcontent-%COMP%] {\n  color: #333;\n}\n.standards-performance-chart-header[_ngcontent-%COMP%] {\n  font-size: 0.875rem;\n  font-family: OpenSans-Semibold;\n  color: #000;\n  padding: 0 24px 0 26px;\n}\n.standards-performance-chart-header-item[_ngcontent-%COMP%] {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n.standards-performance-chart-school[_ngcontent-%COMP%] {\n  hyphens: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 0.875rem;\n  font-family: OpenSans;\n}\n.standards-performance-chart-item[_ngcontent-%COMP%] {\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n.standards-performance-information-icon[_ngcontent-%COMP%] {\n  padding: 0 8px;\n}"] });
